module.exports = __webpack_public_path__ + "static/img/about.c41ce12.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/index/about.jpg
// module id = eI1e
// module chunks = 202